// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_benefit2_name = /** @type {(inputs: {}) => string} */ () => {
	return `Joint Protection`
};

const el_tech_benefit2_name = /** @type {(inputs: {}) => string} */ () => {
	return `Προστασία Αρθρώσεων`
};

const ru_tech_benefit2_name = /** @type {(inputs: {}) => string} */ () => {
	return `Защита суставов`
};

const he_tech_benefit2_name = /** @type {(inputs: {}) => string} */ () => {
	return `הגנה על מפרקים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_benefit2_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_benefit2_name(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_benefit2_name", locale)
	if (locale === "en") return en_tech_benefit2_name(inputs)
	if (locale === "el") return el_tech_benefit2_name(inputs)
	if (locale === "ru") return ru_tech_benefit2_name(inputs)
	if (locale === "he") return he_tech_benefit2_name(inputs)
	return "tech_benefit2_name"
};